<template>
    <common-modal width="small" @emitEvent="emitEvent($event, ['close'])" @close="emitEvent({ name: 'close' })">
        <div v-if="!showConfirmDelete" class="card-list">
            <common-page-header
                :heading="'Saved credit cards'"
                size="page-plain-header"
                contentSpacing="medium"
                :isCenter="true"
            ></common-page-header>
            <common-content-spacer height="medium">
                <div>
                    <div class="card-list--item">
                        <p class="card-list--item__info">{{ $t('pages.billing.billing.billing_list_modal.credit_card') }}</p>
                        <p class="card-list--item__default">{{ $t('pages.billing.billing.billing_list_modal.active') }}</p>
                        <p class="card-list--item__delete">{{ $t('pages.billing.billing.billing_list_modal.delete') }}</p>
                    </div>
                    <div v-for="card in cardList" :key="card.id" class="card-list--item">
                        <div class="card-list--item__info">
                            <p>
                                <span class="card-list--item__brand">{{ card.card.brand }}</span>
                                **** **** **** {{ card.card.last4 }}
                            </p>
                        </div>
                        <div class="card-list--item__default">
                            <checkbox-input :value="card.default" @change="selectionChanged(card)"></checkbox-input>
                        </div>
                        <div class="card-list--item__delete">
                            <common-icon
                                v-if="!card.default"
                                name="trash-bin"
                                size="medium"
                                @click="removeItem(card)"
                            ></common-icon>
                        </div>
                    </div>
                </div>
                <common-buttons align="center">
                    <common-button
                        :isProcessing="isProcessing"
                        :label="$t('common.microcopy.save')"
                        type="primary"
                        @click="saveDefaultCard"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </div>
        <div v-else>
            <common-content-spacer height="medium">
                <div class="card-list--delete">
                    <p>{{ $t('pages.billing.billing.billing_list_modal.delete_card') }}</p>
                    <p class="card-list--delete__card">
                        <span class="card-list--item__brand">{{ deleteCard.card?.brand }}</span>
                        **** **** **** {{ deleteCard.card?.last4 }}
                    </p>
                </div>
                <common-buttons align="center">
                    <common-button
                        :isProcessing="isProcessing"
                        :label="$t('common.microcopy.false')"
                        type="secondary"
                        @click="showConfirmDelete = false"
                    ></common-button>
                    <common-button
                        :isProcessing="isProcessing"
                        :label="$t('common.microcopy.true')"
                        type="primary"
                        @click="confirmDeleteCard()"
                    ></common-button>
                </common-buttons>
            </common-content-spacer>
        </div>
    </common-modal>
</template>

<script>
    import CheckboxInput from 'components/form-inputs/CheckboxInput'
    import PracticesAPI from 'api/PracticesAPI'

    export default {
        components: {
            CheckboxInput,
        },

        data() {
            return {
                isProcessing: false,
                showConfirmDelete: false,
                deleteCard: {},
                cardList: [],
            }
        },

        methods: {
            selectionChanged(card) {
                this.cardList.find((card) => card.default).default = false
                card.default = true
            },

            saveDefaultCard() {
                this.isProcessing = true
                PracticesAPI.setDefaultCard(this.cardList.find((card) => card.default).id).then(() => {
                    this.emitEvent({ name: 'card-saved', payload: this.cardList.find((card) => card.default) })
                    this.isProcessing = false
                })
            },

            removeItem(card) {
                this.deleteCard = card
                this.showConfirmDelete = true
            },

            confirmDeleteCard() {
                PracticesAPI.deleteCard(this.deleteCard.id).then(() => {
                    this.showConfirmDelete = false
                    const index = this.cardList.indexOf(this.deleteCard)
                    this.cardList.splice(index, 1)
                    this.deleteCard = {}
                })
            },

            getPracticeCards() {
                PracticesAPI.getPracticeCards().then((response) => {
                    this.cardList = response
                })
            },
        },

        mounted() {
            this.getPracticeCards()
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    .card-list {
        &--container {
            max-height: 400px;
            overflow-y: auto;
            overflow-x: hidden;
        }

        &--delete {
            p {
                text-align: center;
                margin-bottom: 20px;
            }
            &__card {
                font-size: 20px;
            }
        }

        &--item {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid $color--border-alphabet-table;
            padding: 20px;

            &__info {
                width: 270px;
            }

            &__default {
                width: 50px;
            }

            &__delete {
                width: 50px;

                .icon {
                    cursor: pointer;
                }
            }

            &__brand {
                color: $color--txt-header;
                font-weight: 700;
                text-transform: uppercase;
            }
        }
    }
</style>
